<template>
  <Body class="page-news page-list" />

  <section class="page-header">
    <div class="wrap">
      <div class="text">
        <h1 class="title">
          {{ $t('주요소식') }}
        </h1>
        <div class="desc">
          세상에 전하는 사랑과 평화의 이야기. <br>
          ‘어머니 사랑과 평화의 날’ 캠페인의 다양한 소식을 만나보세요.
        </div>
      </div>
    </div>
  </section>

  <section class="section section-list">
    <div v-if="total >= 1" class="wrap">
      <ul class="lists list-news">
        <li v-for="news in newsList" :key="news.id" class="list-item">
          <NuxtLink :to="localePath(`/news/${news.id}`)" class="item list-link">
            <div class="thum" :class="{ default: news.thumbnailUrl == null }">
              <div
                class="thum-img"
                :style="{ backgroundImage: `url(${news.thumbnailUrl ?? defaultThumbnail})` }"
              />
            </div>
            <div class="info">
              <div class="post-title" v-html="news.title" />
              <div class="post-excerpt" v-html="news.contents" />
              <div class="post-info">
                <div class="detail">
                  <div class="date">
                    {{ formatIntlDate(new Date(news.createdAt), locale) }}
                  </div>
                  <div class="view">
                    <i class="ico ico-smile" />{{ formatNumber(news.viewCnt, locale) }}
                  </div>
                  <div class="comment">
                    <i class="ico ico-reply" />{{ formatNumber(news.commentCnt, locale) }}
                  </div>
                  <div class="like">
                    <i class="ico ico-heart-round" />{{ formatNumber(news.likeCnt, locale) }}
                  </div>
                </div>
              </div>
            </div>
          </NuxtLink>
        </li>
      </ul>
    </div>

    <!-- nodata -->
    <div v-if="total === 0" class="no-data wrap">
      {{ $t('등록된글이없어요') }}
    </div>

    <Paging
      v-if="total >= 1"
      :page-size="pageSize"
      :total-count="total"
      :page="page"
      @update:page="page = $event"
    />
  </section>
</template>

<script lang="ts" setup>
interface NewsListItem {
  id: number
  thumbnailUrl: string | null
  title: string
  contents: string
  createdAt: string
  viewCnt: number
  commentCnt: number
  likeCnt: number
}

const { $t } = useNuxtApp()
const { locale } = useI18n()
const { defaultThumbnail } = useReview()

useHead({
  title: `${$t('뉴스')} - ${$t('어머니사랑과평화의날캠페인')}`,
  link: [{ rel: 'stylesheet', href: `/css/news.css?${useBuildTime()}` }],
})

const localePath = useLocalePath()

const pageSize = 9
const page = ref(1)

const { data: newsData } = await useFetch<{ news: NewsListItem[], total: number }>('/api/news', {
  method: 'GET',
  query: { languageGbSn: locale.value, page, pageSize },
  watch: [page],
})
const newsList = computed(() => newsData.value?.news ?? [])
const total = computed(() => newsData.value?.total ?? 0)
</script>

<style scoped>
.news-grid{display:grid; grid-template-columns:1fr; gap:24px}
@media (min-width:768px){.news-grid{grid-template-columns:repeat(2, 1fr)}}
@media (min-width:1070px){.news-grid{grid-template-columns:repeat(3, 1fr)}}
</style>
